import React, { Component } from 'react'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import SrchResults from './SrchResults'
import { doLocationSearch, getMetaData } from './SearchRoutines'

const fieldInputs = {
	srchName: {label: 'Enter Location:', placeholder: "City,state or zip code"}
}
let requestBbox = null
const srchRadius = 60.0 //miles
const idPriority = [5, 3, 1, 17, 19]
//const idPriority = [5, 3, 1, 17, 19, 27, 22, 11, 28, 26, 31]

export default class StationSearch extends Component {
	constructor(props) {
		super(props)
		this.state = {
			srchProgress: "",
			srchError: "",
			stationList: [],
			srchName: "",
		}
	}
	
	onNameChange = (event) => {
		this.setState({srchName:event.target.value, srchError: "", srchProgress: "", stationList: []});
	}

	onSearch = () => {
		this.setState({stationList: []});
		if (this.state.srchName.length > 0) {
			this.setState({srchProgress: "Searching for location..."});
			doLocationSearch(this.state.srchName, srchRadius)
				.then(data => {
					requestBbox = data.requestBbox
					this.setState({srchProgress: "Searching for stations..."});
					getMetaData({bbox: requestBbox, elems: this.props.selectedElem}, idPriority, data.srchCenter)
						.then(results => this.setState(results))
						.catch(error =>  this.setState({srchError: error, srchProgress: ""}))
				})
				.catch(error => this.setState({srchError: 'Search error: '+error, srchProgress: ""}))
		} else {
			alert("Must specify a location");
		}
	}

	render() {
		return (
			<div>
				{this.props.showSearch &&
					<div style={{border:'1pt solid rgba(0, 0, 0, 0.23)', display:'inline-block', padding:'1em', margin:'1em 0 0.5em 0', background:'#f1f1f1'}}>
						<div style={{display:'inline-block'}}>
							<TextField
								name="srchName"
								placeholder={fieldInputs.srchName.placeholder} 
								label={fieldInputs.srchName.label}
								value={this.state.srchName}
								onChange={this.onNameChange}
								margin="normal"
								variant="outlined"
								autoFocus={true}
							/> 
							<br />
							<Button 
								onClick={this.onSearch} 
								variant="contained"
								size="small"
								color="primary"
								style={{marginTop: "1em"}}
							>
								Search
							</Button>
						</div>
						<div style={{display:'inline-block', verticalAlign:'top', marginLeft:'2em'}}>
							<SrchResults 
								requestBbox={requestBbox}
								srchProgress={this.state.srchProgress}
								srchError={this.state.srchError}
								stationList={this.state.stationList} 
								selectedElem={"wind"} 
								updateStation={this.props.updateStation}
							/>
						</div>
					</div>
					}
	  		</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/StationSearch.jsx